import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  const AUTH_SESSION_KEY = "auth_token";
  const isAuthenticated = localStorage.getItem(AUTH_SESSION_KEY)
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  return <> <Outlet/> </>
};

export default ProtectedRoutes;